import type { ColumnDef } from '@tanstack/react-table';

import { type GetBadgesQuery } from 'data/__generated__';
import { textColumn } from 'components/DataTable';

import { TotemImage } from 'components/TotemImage';
import { BADGE_TYPES } from './types';

export type BadgeRow = GetBadgesQuery['badges'][number];

type BadgeFilterInput = {
    searchValue: string;
};

export const badgesColumns: ColumnDef<BadgeRow, unknown>[] = [
    textColumn<BadgeRow, BadgeFilterInput>({
        accessorKey: 'imageUrl',
        header: 'Logo',
        defaultVisible: true,
        cell: ({ row }) => (
            <TotemImage
                src={`${window.__TOTENV__.BASE_CLOUDFRONT_IMAGE_URL}${row.original.imageUrl}`}
                alt={row.original.name}
                size={28}
            />
        ),
    }),
    textColumn<BadgeRow, BadgeFilterInput>({
        accessorKey: 'name',
        header: 'Nom',
        defaultVisible: true,
    }),
    textColumn<BadgeRow, BadgeFilterInput>({
        accessorKey: 'type',
        header: 'Type',
        defaultVisible: true,
        cell: ({ row }) => BADGE_TYPES[row.original.type],
    }),
    textColumn<BadgeRow, BadgeFilterInput>({
        accessorKey: '_id',
        header: 'ID',
        defaultVisible: true,
    }),
];
